import React, { useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Typography,
  Divider,
  Alert,
  Checkbox,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { handleKeyPress } from "../../common/Events";
import verifyOtpService from "../../services/verifyOtpService";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import requestOTPService from "../../services/requestOtpService";
import CaptchCaptur from "./CaptchCaptur";
import submitRegistrationService from "../../services/submitRegistrationService";
import { getCaptchNewCodeImg } from "../../services/captchservice";
import { useNavigate } from "react-router-dom";
import TermAndConditionPopup from "./TermAndConditionPopup";
import PrivacyPolicyPopup from "./PrivacyPolicyPopup";
import OTPVerificationAlertBox from "./OTPVerificationAlertBox";
import ConfirmationDialog from "./ConfirmationDialog";

const ThirdStep = ({
  onClickNext,
  handleBack,
  formData,
  resendCount,
  setResendCount,
  setFormData,
  resetForm,
}) => {
  const { showNotification } = useNotificationContext();
  const formOption = {
    defaultValues: { ...formData },
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm(formOption);
  const { setLoading } = useLoading();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [otpVerified, setOtpVerified] = useState(false);
  const [resendDisable, setResendDisable] = useState(false);
  const [open, setOpen] = useState(false);
  const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [registeredResponse, setRegisteredResponse] = useState(null);
  const navigate = useNavigate();
  const [resObj, setresObj] = useState({ fileName: "", captcha_txt: "" });
  const [captchImg, setCaptchImg] = useState(null);
  const [otpVerifiedApiCallMoreThen3, setOtpVerifiedApiCallMoreThen3] =
    useState(false);
  const [attemptsExhausted, setAttemptsExhausted] = useState(false);

  const onSubmitOtpVerify = async (data) => {
    try {
      setLoading(true);
      const requestBody = {
        ...formData,
        ...data,
      };

      const response = await verifyOtpService(baseUrl, requestBody);
      if (response.messageCode === 6 && response?.messageType === "SUCCESS") {
        setOtpVerified(true);
        showNotification("Info", "OTP Verified", "success");
      } else if (
        response.messageCode === 6 &&
        response?.messageType === "ERROR"
      ) {
        showNotification("Error", response?.message ?? "OTP expired");
      } else if (response.otpStatus === 17) {
        setOtpVerifiedApiCallMoreThen3(true);
      } else {
        showNotification("Error", response?.message ?? "Failed To Verify OTP");
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Verify OTP");
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const requestBody = {
        fileName: resObj.fileName,
        text: resObj.captcha_txt,
        applicationId: formData?.applicationId,
      };

      const response = await submitRegistrationService(baseUrl, requestBody);
      if (response.messageCode === 6 && response?.messageType === "SUCCESS") {
        setShowConfirmation(true);
        setRegisteredResponse(response);
      } else {
        onReloadCaptch();
        showNotification(
          "Error",
          response?.message ?? "Failed to Register User"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Captcha Not Valid");
    } finally {
      setLoading(false);
    }
  };

  const onReloadCaptch = async () => {
    try {
      setAttemptsExhausted(false);

      setLoading(true);
      const requestBody = {
        fileName: resObj.fileName,
      };

      const refreshCaptchResponse = await getCaptchNewCodeImg(
        baseUrl,
        requestBody
      );
      if (
        refreshCaptchResponse.messageCode === 6 &&
        refreshCaptchResponse?.messageType === "SUCCESS"
      ) {
        setCaptchImg(refreshCaptchResponse?.text);
        setresObj({ ...resObj, captcha_txt: "" });
      } else if (refreshCaptchResponse.messageCode === 2) {
        setAttemptsExhausted(true);
        setCaptchImg("");
        setresObj({
          ...resObj,
          captcha_txt: "",
        });
        showNotification(
          "Error",
          refreshCaptchResponse?.message ?? "Failed To Reload Captcha"
        );
      } else {
        setCaptchImg("");
        showNotification(
          "Error",
          refreshCaptchResponse?.message ?? "Failed To Reload Captcha"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed To Reload Captcha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container className="bg-white">
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 4 }}>
            {!otpVerified && (
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      display="flex"
                      justifyContent="center"
                    >
                      <Typography
                        variant="subheader"
                        sx={{ alignItems: "left", fontSize: "14px" }}
                      >
                        Please enter the one time password to verify your
                        account.
                        <br />A code has been sent to{" "}
                        {formData?.vendorSPOCemail}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <TextField
                        className="stepperFormInput"
                        name="otp"
                        fullWidth
                        type="number"
                        onKeyDown={handleKeyPress}
                        required
                        size="small"
                        disabled={otpVerified}
                        autoComplete="off"
                        {...register("otp", {
                          required: true,
                          pattern: {
                            message: "Enter valid 6 digit OTP.",
                          },
                        })}
                        error={Boolean(errors?.otp)}
                        helperText={errors?.otp ? "Enter a valid OTP" : ""}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          pt: 2,

                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          variant="text"
                          onClick={async () => {
                            try {
                              setResendDisable(true);
                              setTimeout(() => {
                                setResendDisable(false);
                              }, 30000);
                              setLoading(true);
                              setResendCount((prevValue) => {
                                return prevValue + 1;
                              });

                              await requestOTPService(baseUrl, formData);
                            } catch (err) {
                              showNotification(
                                "Error",
                                err?.message ?? "Failed to request OTP"
                              );
                            } finally {
                              setLoading(false);
                            }
                          }}
                          sx={{ mr: 2 }}
                          disabled={resendDisable || resendCount >= 3}
                        >
                          Resend
                        </Button>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={handleSubmit(onSubmitOtpVerify)}
                          sx={{ mr: 1, color: "white" }}
                        >
                          Verify
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            )}
            {otpVerified && (
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  pt: 2,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Alert severity="success" style={{ width: "55%" }}>
                  Otp Verified Successfully{" "}
                </Alert>
              </Grid>
            )}
            {otpVerified && (
              <CaptchCaptur
                setresObj={setresObj}
                resObj={resObj}
                register={register}
                setCaptchImg={setCaptchImg}
                captchImg={captchImg}
                onReloadCaptch={onReloadCaptch}
                applicationId={formData?.applicationId}
                attemptsExhausted={attemptsExhausted}
                setAttemptsExhausted={setAttemptsExhausted}
              />
            )}
            {otpVerified && (
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "center" }}>
                  {" "}
                  <Typography sx={{ fontSize: "12px" }}>
                    <Checkbox
                      sx={{ borderRadius: 10, pl: 0 }}
                      type="checkbox"
                      name="termandcondition"
                      {...register("termandcondition", {
                        required: true,
                      })}
                      required
                      checked={watch("termandcondition")}
                    />
                    I Agree to{" "}
                    <TermAndConditionPopup open={open} handleClose={setOpen} />
                    {` and `}
                    <PrivacyPolicyPopup
                      open={privacyPolicyOpen}
                      handleClose={setPrivacyPolicyOpen}
                    />
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
          <Divider />
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", p: 2 }}>
              <Button
                type="submit"
                onClick={handleBack}
                sx={{ mr: 1 }}
                variant="outlined"
                disabled={otpVerified}
              >
                Back
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit)}
                sx={{ mr: 1 }}
                disabled={
                  !otpVerified ||
                  !watch("termandcondition") ||
                  resObj?.captcha_txt?.length === 0
                }
                variant="outlined"
              >
                Submit
              </Button>
            </Box>
            {otpVerifiedApiCallMoreThen3 && (
              <OTPVerificationAlertBox
                open={otpVerifiedApiCallMoreThen3}
                setOpen={setOtpVerifiedApiCallMoreThen3}
                resetForm={resetForm}
              />
            )}
          </React.Fragment>
        </Grid>
      </Grid>
      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          appointmentData={registeredResponse}
          handleClose={() => {
            setShowConfirmation(false);
            navigate("/login");
            showNotification(
              "Success",
              "Vender Registered Successfully ",
              "success"
            );
          }}
        />
      )}
    </>
  );
};

export default ThirdStep;
